import * as React from 'react';
import {Link} from "gatsby";

const CallToAction = ({text}) => {
    return (
        <div className="bg-primary py-4">
            <p className="text-center">
                <p className="fs-5 text-white">{text}</p>
                <Link className="btn btn-lg btn-secondary" to="/kontakt" role="button">
                    <i className="bi-chevron-double-right pe-2"></i> Przejdź do kontaktu
                </Link>
            </p>
        </div>
    )
}
export default CallToAction